<template>
  <v-autocomplete
    v-bind="$attrs"
    :model-value="modelValue"
    multiple
    autocomplete="off"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #selection="{ item, index }">
      <span v-if="index < 2">{{ index > 0 ? ', ' : '' }}{{ item.title }}</span>
      <span v-else-if="index === 2" class="text-grey text-caption ml-1">(+{{ (modelValue?.length ?? 0) - 2 }})</span>
    </template>
  </v-autocomplete>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });
defineProps<{ modelValue?: unknown[] }>();
defineEmits<{ 'update:modelValue': [value: unknown[]] }>();
</script>
